import buildUrl from "../utils/buildUrl";
import { baseUrl } from "./baseUrl";

export const getSequenceRoute = () => buildUrl({ url: `${baseUrl}/dict-api/sequences/` });

export const updateSequenceRoute = (seqName: string, value: number) =>
  buildUrl({
    url: `${baseUrl}/dict-api/sequences/${seqName}`,
    searchParams: { nextValue: value },
  });
